import {
    productCode118,
    productCodeBamboo,
    productCodeBudgetMoney,
    productCodeCoopPlata,
    productCodeFluro,
    productCodePlata,
} from '@ilg-totallymoney/cardloanutils'

export const productCodeMonzo = '99999781'

export const supportedSameDayDepositLoanIds = [
    productCode118,
    productCodeBamboo,
    productCodeBudgetMoney,
    productCodeCoopPlata,
    productCodeFluro,
    productCodePlata,
    productCodeMonzo,
]

export const canShowSameDayDepositBadge = (loanId: string) =>
    supportedSameDayDepositLoanIds.includes(loanId)
